/**
 * Returs the client locale from browser, retuns en as fallback.
 */
import getLocale from "browser-locale";

export default () => {
  const locale = getLocale();
  return locale || "en";
};
